import React from 'react';
import { packItems } from '../data/landing';
export function PackSection() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-76" data-mp="2od4lv7guak5y">
      <div className="mx-auto max-w-4xl px-5 md:px-8" data-id="element-77" data-mp="2odebuv1vwrbn">
        <h2 className="text-center font-serif text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-78" data-mp="2jd8se25rqb4n">
          Todo lo que recibís en un solo pack
        </h2>
        <ol className="mt-12 overflow-hidden rounded-2xl border border-line bg-white" data-id="element-79" data-mp="2fe9ie356jo6c">
          {packItems.map(({
          icon: Icon,
          title,
          text
        }, i) => <li key={title} className={`flex items-start gap-5 p-6 md:items-center md:p-7 ${i > 0 ? 'border-t border-line' : ''} ${i === 0 ? 'bg-gold-light/60' : ''}`} data-id="element-80" data-mp="25ksnswx7y51m" data-mpi={i}>
              <span className="font-serif text-3xl font-semibold leading-none text-gold md:w-8" data-id="element-81" data-mp="1voz1wmxm0z76">{i + 1}</span>
              <Icon className="mt-1 h-6 w-6 shrink-0 text-gold-dark md:mt-0" aria-hidden="true" data-id="element-82" data-mp="1rlkm9xdl2ku9" />
              <div className="flex-1" data-id="element-83" data-mp="1mokdvft9h5zz">
                <h3 className="font-serif text-2xl font-semibold leading-tight text-ink" data-id="element-84" data-mp="1mplxw9s992tu">
                  {title}
                  {i === 0 && <span className="ml-3 align-middle font-sans text-xs font-bold uppercase tracking-wider text-gold-dark" data-id="element-85" data-mp="2hum50unuwqzc">
                      Principal
                    </span>}
                </h3>
                <p className="mt-1 text-muted" data-id="element-86" data-mp="284koqp1qwcuz">{text}</p>
              </div>
            </li>)}
        </ol>
        <p className="mt-6 text-center font-bold text-ink" data-id="element-87" data-mp="2vu5cdl8ufyal">
          4 recursos digitales para acompañar tu fe, tu estudio y tu crecimiento interior.
        </p>

        <div className="mx-auto mt-20 max-w-2xl text-center" data-id="element-88" data-mp="30rdujltzs2bu">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-89" data-mp="2mt742qrdh4m7">
            Empezá hoy a dedicarle más tiempo a tu fe
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-ink/80" data-id="element-90" data-mp="1beadhcfji7cq">
            No necesitás esperar al domingo, a un momento difícil o a que todo esté en orden para acercarte a la Palabra.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-91" data-mp="3i3lrctm9dlix">
            Podés empezar hoy, con unos minutos de lectura, una oración sincera y la intención de seguir creciendo.
          </p>
        </div>
      </div>
    </section>;
}